<template>
  <ConfirmationPopup
    ref="confirmationPopup"
    type="warning"
    :closeable="true"
    title="Обмеження страхової компанії"
    message=""
    :controls="controls"
    :max-width="500"
    @close="onClose"
  >
    <p class="blacklist__message">
      Клієнт внесений до чорного списку цієї страхової компанії.
    </p>
    <p class="blacklist__hint">
      Будь ласка, оберіть іншу страхову для продовження оформлення.
    </p>
  </ConfirmationPopup>
</template>

<script>
import { ConfirmationPopup } from '@/shared/ui/popup';

export default {
  components: { ConfirmationPopup },
  computed: {
    controls() {
      return [{ type: 'default', label: 'Закрити', event: 'close' }];
    },
  },
  methods: {
    open() {
      this.$refs.confirmationPopup.open();
    },
    close() {
      this.$refs.confirmationPopup?.close();
    },
    onClose() {
      this.$emit('closed');
    },
  },
};
</script>

<style scoped lang="scss">
.blacklist {
  &__message {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 16px;
  }

  &__hint {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }
}
</style>
